import { action } from 'mobx'
import BaseStore from '@common/Table/store'
import Api from '@api/xi_feng/jiamengGoods.js'
class Store extends BaseStore {
  id

  $listApi = Api.getDirectSupplyGoods

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  $getParams = () => {
    return {
      ...this.$params,
      property_id: this.id
    }
  }

  @action
  addSupplyMeal = async id => {
    const { success } = await Api.addSupplyMeal({ set_meal_id: id })
    if (success) {
      this.$list.find(item => item.id === id).is_selected = 1
      this.tableForceUpdate()
    }
  }

  @action
  removeSupplyMeal = async id => {
    const { success } = await Api.removeSupplyMeal({ set_meal_id: id })
    if (success) {
      this.$list.find(item => item.id === id).is_selected = 0
      this.tableForceUpdate()
    }
  }
}

export default Store
